import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export default class Time {

	timers: any = new Array();

	newTimer(id, func, interval) {
		if (this.getTimer(id)) {
			this.deleteTimer(id);
		}
		this.timers[id] = window.setInterval(() => { func() }, interval);
	}

	getTimer(id) {
		return this.timers[id];
	}

	deleteTimer(id) {
		if (this.timers[id]) {
			window.clearInterval(this.timers[id]);
			delete this.timers[id];
		}
	}

}